import { CompRef, DocumentServicesObject } from '@wix/document-services-types';

import { PlatformContext } from './types';
import {
  PlatformApiMethods,
  ActionMetadata,
} from '@wix/editor-platform-host-integration-apis';
import { IEditorPlatformPackagesBridge } from '@wix/editor-platform-interfaces';
import { ComponentsPlatformService } from '@wix/editor-platform-manifest-services';
import { EditActionsAPI } from './EditActionsAPI';

import {
  EditorPointer,
  EditorPointerServiceAPI,
} from '@wix/editor-document-logic-api';

export function initEditActionsServices(
  documentServicesAPI: DocumentServicesObject,
  componentsAPI: ComponentsPlatformService,
  hostAPI: PlatformApiMethods,
  isBuilderServicesEnabled: boolean,
  editorPlatformPackagesBridge: Partial<IEditorPlatformPackagesBridge>,
  editorPointerAPI?: EditorPointerServiceAPI,
) {
  if (!isBuilderServicesEnabled || !editorPointerAPI) {
    return {
      generateEditActions: () => ({
        nativeActions: [],
        customActions: [],
        systemActions: [],
      }),
    };
  }

  function generateEditActions(
    editorPointers: EditorPointer<CompRef>[],
    actionMetadata?: ActionMetadata,
  ) {
    const platformContext: PlatformContext = {
      editorPointers,
      editorPointer: editorPointers[0],
      editorPointerAPI: editorPointerAPI!,
      documentServicesAPI,
      componentsAPI,
      hostAPI,
      editorPlatformPackagesBridge,
      actionMetadata,
    };

    const api = new EditActionsAPI(platformContext);
    return api.getEditActions();
  }

  return {
    generateEditActions,
  };
}
